import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import styles from './styles'

import Photo from 'public/assets/svg/thumb_photo.svg'
import Video from 'public/assets/svg/thumb_video.svg'
import Pano from 'public/assets/svg/thumb_pano.svg'
import Instagram from 'public/assets/svg/instagram.svg'
import Stop from 'public/assets/svg/thumb_stop.svg'
import { MEDIA_TYPES, NETWORK_TYPES } from 'aria-viewer/tour/constants'

const MediaIcon = props => {
    const { text = '', mediaType, network, children, classes } = props

    return (
        <>
            {children || (
                <div className={classes.container}>
                    {text && <span className={classes.text}>{text}</span>}
                    {mediaType && (
                        <span className={classes.iconContainer} data-testid="svgStyle">
                            {(() => {
                                if (network === NETWORK_TYPES.instagram) {
                                    return <img src={Instagram} />
                                }
                                switch (mediaType) {
                                    case MEDIA_TYPES.photo:
                                        return <img src={Photo} />
                                    case MEDIA_TYPES.video:
                                        return <img src={Video} />
                                    case MEDIA_TYPES.pano:
                                    case MEDIA_TYPES.panorama:
                                        return <img src={Pano} />
                                    case MEDIA_TYPES.stop:
                                        return <img src={Stop} />
                                }
                            })()}
                        </span>
                    )}
                </div>
            )}
        </>
    )
}
MediaIcon.defaultProps = {
    text: '',
    showBackground: true,
    mediaType: undefined,
    children: null,
}
export default compose(injectSheet(styles))(MediaIcon)
